import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSettings, DEFAULT_SETTINGS } from '../hooks/useSettings';

export function AnnouncementBar() {
  const { data } = useSettings();
  const settings = data ?? DEFAULT_SETTINGS;

  if (settings.announcementBarEnabled === false) return null;

  return (
    <div className="bg-[#0e2c1e] py-2.5 text-ivory">
      <div className="container-page flex items-center justify-between text-xs font-medium tracking-wide">
        <button
          type="button"
          aria-label="Previous announcement"
          className="flex h-5 w-5 items-center justify-center opacity-75 transition-opacity hover:opacity-100"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>

        <span className="text-center font-body text-[11px] md:text-xs">
          {settings.announcementBarText || 'Free shipping on orders over $50'}
        </span>

        <button
          type="button"
          aria-label="Next announcement"
          className="flex h-5 w-5 items-center justify-center opacity-75 transition-opacity hover:opacity-100"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
